import { render } from "./brush-circle.svg?vue&type=template&id=b84b99e8?inline"
const script = {}
script.render = render

export default script